import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=aa48d1da&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=aa48d1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa48d1da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa48d1da')) {
      api.createRecord('aa48d1da', component.options)
    } else {
      api.reload('aa48d1da', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=aa48d1da&scoped=true&", function () {
      api.rerender('aa48d1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/SearchFilterTokens.vue"
export default component.exports